// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"362":"ee0a6af5","538":"7502cfce","545":"363a01e3","566":"91fedc76","596":"e84734bb","614":"084c75c7","676":"b6a0283a"}[chunkId] + ".chunk.js";
};